/* eslint-disable no-use-before-define */
import React from 'react'
import { getState, Status, arrayFrom, ajax, evalJson, parseDate, numberFrom, sortFn } from '../twd/twd'

const Last = getState('order-ticket-positions.last', {
    ts: 0,
    positions: [],
    positionsCount: 0,
    positionsStatus: Status.NULL,
})

export const resetLastPositionsInfo = ({ts=0} = {}) => {
    Last.reset()
    Last.set({
        ts,
        positions: [],
        positionsCount: 0,
        positionsStatus: Status.NULL,
    })
}

export default ({acctNo, cusip, ts}) => {

    const [positions, setPositions_] = React.useState(Last.value.positions || [])
    const setPositions = React.useCallback((positions) => {
        Last.set({positions})
        setPositions_(positions)
    }, [])

    const [positionsCount, setPositionsCount_] = React.useState(Last.value.positionsCount || 0)
    const setPositionsCount = React.useCallback((positionsCount) => {
        Last.set({positionsCount})
        setPositionsCount_(positionsCount)
    }, [])

    const [positionsStatus, setPositionsStatus_] = React.useState(Last.value.positionsStatus || Status.NULL)
    const setPositionsStatus = React.useCallback((positionsStatus) => {
        Last.set({positionsStatus})
        setPositionsStatus_(positionsStatus)
    }, [])

    const lastAbort = React.useRef()
    const [positionsAcctNo, setPositionsAcctNo] = React.useState(null)

    const updatePositions = async ({acctNo,isReset}) => {
        if (!isReset && positionsAcctNo && positionsAcctNo === acctNo) return

        try {
            setPositionsAcctNo(acctNo)
            setPositionsCount(0)

            if (!acctNo) {
                setPositionsStatus(Status.NULL)
                return
            }

            if (lastAbort.current) { lastAbort.current() }

            setPositionsStatus(Status.LOADING)

            const { data:data_, abort:abort_ } = await ajax({
                url: '/esb/portfolio/trades/holdings',
                type: 'text',
                method: 'POST',
                params: {p_acct_no: acctNo}
            })

            lastAbort.current = abort_
            const data = evalJson(await data_, {
                position: global.app.config.holdings.filter(({acctNo:acctNo_}) => acctNo_ === acctNo)
            })

            const ps = arrayFrom(data.position)
                .filter(({maturity}) => {
                    const isMatured = parseDate(maturity) < Date.now()
                    return !isMatured
                })
                .sort(sortFn(({issue}) => (issue || '').trim() ))

            setPositions(ps)
            setPositionsCount(ps.length)
            setPositionsStatus(Status.LOADED)

        } catch(e) {

            setPositions([])
            setPositionsCount(0)
            setPositionsStatus(Status.FAILED_TO_LOAD)
        }
    }

    const [positionsTotalQty, setPositionsTotalQty] = React.useState(0)
    React.useEffect(() => {(async () => {
        try {
            const v = positions
                .filter(({cusip:cusip_}) => cusip ===  cusip_)
                .reduce((x, {qty}) => x + numberFrom(qty, 0), 0)
            setPositionsTotalQty(v)
        } catch(e) {
            setPositionsTotalQty(0)
        }
    })()}, [positions, cusip])

    const reset = () => {
        Last.reset()
        setPositionsAcctNo(null)
        setPositions([])
        setPositionsCount(0)
        setPositionsStatus(Status.NULL)
    }

    return {
        positions,
        positionsCount,
        positionsStatus,
        positionsTotalQty,
        updatePositions,
        reset,
    }

}
